import { Gift, ChevronsRight } from 'lucide-react';
import Axios from '@/services/axios';
import { useAuthContext } from '@context/useAuthStore';
import { useNavigate } from 'react-router-dom';

function FreeButton({ setIsLoading }) {
  const navigate = useNavigate();
  const axios = Axios;
  const { refetchSubscription } = useAuthContext();

  const activateFreePlan = async () => {
    try {
      const data = {
        subscription_code: 'free',
      };
      setIsLoading(true);
      await axios.post('/user/subscription/activate', data);
      await refetchSubscription();
      navigate('/');
    } catch (error) {
      alert('An error occurred while activating the free plan. Please try again later.');
    }
    setTimeout(setIsLoading(false), 2000);
  };

  return (
    <div className="flex justify-center my-6">
      <button
        onClick={activateFreePlan}
        className="relative group px-10 py-4 rounded-full font-bold text-lg transition-all duration-300
    bg-gradient-to-r from-[#00C6FF] to-[#0072FF] text-white
    hover:from-[#0072FF] hover:to-[#00C6FF]
    shadow-xl hover:shadow-2xl transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-400/50
    flex items-center justify-center gap-2 animate-pulse-once">
        <Gift className="w-5 h-5" />
        Start for Free
        <ChevronsRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
      </button>
    </div>
  );
}

export default FreeButton;
